export default __webpack_public_path__ + "static/media/bci-11-hover.9d5a07da.svg";